module.exports = __webpack_public_path__ + "img/KH-注册3.0f33c2a3.png";